import { createPortal } from 'react-dom'
import styles from './index.module.scss'
import { useTranslation } from 'react-i18next'
const SocketConnetShow = () => {
  const { t } = useTranslation()
  return createPortal(
    <div className={styles.socketConnetShow}>
      <div className={styles.socketConnetShowContent}>
        <div className={styles.socketConnetShowContentTitle}>{t('explorer_312')}</div>
        <div className={styles.socketConnetShowContentText}>{t('explorer_313')}</div>
        <div
          className={styles.socketConnetShowContentButton}
          onClick={() => {
            window.location.reload()
          }}
        >
          {t('explorer_314')}
        </div>
      </div>
    </div>,
    document.body,
  )
}

export default SocketConnetShow
